export default __webpack_public_path__ + "static/media/download-icon.bea9c725.svg";